import React from 'react';

export function addSeparatorBetweenElements(
  elementsArray: Array<React.ReactElement>,
  separator: string,
): Array<React.ReactElement | string> {
  return elementsArray.reduce(
    (acc: Array<React.ReactElement | string>, tag, index) => {
      if (index > 0 && index < elementsArray.length) {
        acc.push(separator);
      }
      // eslint-disable-next-line react/no-array-index-key
      acc.push(React.cloneElement(tag, { key: `subtitle-${index}` }));
      return acc;
    },
    [],
  );
}

export function createRandomKey() {
  return `${String(Math.random())}-${String(new Date().getTime())}`;
}
